<template>
    <div v-if="editable || value.length">
        <df-solutions :solutions="selectedSolutions" v-if="selectedSolutions">
            <button slot="tools" slot-scope="{ solution }" class="btn btn-danger" :title="`«${solution.title}» entfernen`" @click.prevent="removeSolution(solution)" v-if="editable">
                <span class="icon mdi mdi-close text-white"></span>
            </button>
            <div slot="empty"></div>
        </df-solutions>

        <be-modal dismissible full-width effect="3" header-color="dark" :show.sync="showModal" title="Solutions hinzufügen" v-if="showModal">
            <df-solutions filterable :default-category="frameworkCategory" :solutions="unselectedSolutions">
                <button slot="tools" slot-scope="{ solution }" class="btn btn-primary" :title="`«${solution.title}» hinzufügen`" @click.prevent="addSolution(solution)">
                    <span class="icon mdi mdi-plus text-white"></span>
                </button>
            </df-solutions>
        </be-modal>
    </div>
</template>

<script>
    import ReportItem from '../../../../models/ReportItem';
    import Solutions from '../../../../data/Solutions';

    import DfSolutions from '../../../blocks/DfSolutions';

    export default {
        components: { DfSolutions },

        props: {
            editable: Boolean,
            value: Array,
            reportItem: ReportItem,
        },

        data: () => ({
            showModal: false,
        }),

        computed: {
            selectedSolutions: vm => vm.solutions.filter(solution => vm.value.includes(solution.resourceId)),
            unselectedSolutions: vm => vm.solutions.filter(solution => !vm.value.includes(solution.resourceId)),
        },

        asyncComputed: {
            solutions: {
                get: () => Solutions.all(),
                default: [],
            },
            frameworkCategory: vm => vm.reportItem.getFrameworkCategory(),
        },

        methods: {
            open() {
                this.showModal = true;
            },

            addSolution(solution, notify = true) {
                this.$emit('input', this.value.concat([solution.resourceId]));

                if (!notify) {
                    return;
                }

                this.$store.dispatch('notifications/add', {
                    color: 'primary',
                    title: `«${solution.title}» hinzugefügt`,
                    description: 'Die Digital.Solution wurde zum Report hinzugefügt.',
                    actionText: 'Rückgängig',
                    action: () => {
                        this.removeSolution(solution, false);
                    },
                });
            },

            removeSolution(solution, notify = true) {
                this.$emit('input', this.value.filter(value => value !== solution.resourceId));

                if (!notify) {
                    return;
                }

                this.$store.dispatch('notifications/add', {
                    color: 'primary',
                    title: `«${solution.title}» entfernt`,
                    description: 'Die Digital.Solution wurde aus dem Report entfernt.',
                    actionText: 'Rückgängig',
                    action: () => {
                        this.addSolution(solution, false);
                    },
                });
            },
        },
    };
</script>
